const binding = { modules: {}, dataActions: {} };

    (binding.modules['localy-theme'] = {
        c: () => require('partner/themes/localy-theme/localy-theme.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','content-block','header','media-gallery','navigation-menu','promo-banner','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'localy-theme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'localy-theme.theme.settings.json',
        md: 'src/themes/localy-theme'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };